import { render } from "./appConfiguration.vue?vue&type=template&id=33f2c608"
import script from "./appConfiguration.vue?vue&type=script&lang=js"
export * from "./appConfiguration.vue?vue&type=script&lang=js"

import "./appConfiguration.vue?vue&type=style&index=0&id=33f2c608&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__